import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import shellStyles from '../components/shell/shell.module.css';
import ui from '../styles/ui.module.css';

function pct(v: number): string {
  return `${(v * 100).toFixed(2)}%`;
}

function days(iso: string): number {
  return Math.floor((Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24));
}

/** Admin · Saúde operacional — sinal acionável, não vaidade de número: lojas paradas em
 *  rascunho, chargeback fora da curva, campanha falhando. Consome `GET /api/admin/health`. */
export function Saude() {
  const health = useQuery({ queryKey: ['admin', 'health'], queryFn: () => api.health() });
  const h = health.data;

  return (
    <>
      <div className={shellStyles.head}>
        <h1>Saúde</h1>
        <p>O que precisa de atenção agora, não vaidade de número.</p>
      </div>

      {health.isLoading ? (
        <p className={ui.empty}>Carregando…</p>
      ) : (
        <>
          <section>
            <div className={ui.secH}>
              <h2>Lojas paradas em rascunho (há mais de 7 dias)</h2>
            </div>
            <div className={ui.card}>
              {!h?.stuckInDraft.length ? (
                <p className={ui.empty}>Nenhuma loja parada.</p>
              ) : (
                <div className={ui.tblScroll}>
                  <table className={ui.tbl}>
                    <thead>
                      <tr>
                        <th>Loja</th>
                        <th className="r">Parada há</th>
                      </tr>
                    </thead>
                    <tbody>
                      {h.stuckInDraft.map((s) => (
                        <tr key={s.id}>
                          <td>
                            <b>{s.name}</b>
                            <div className={ui.faint}>{s.subdomain}</div>
                          </td>
                          <td className="r">
                            <span className={ui.mono}>{days(s.createdAt ?? new Date().toISOString())} dia(s)</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </section>

          <section>
            <div className={ui.secH}>
              <h2>Chargeback fora da curva</h2>
            </div>
            <div className={ui.card}>
              {!h?.chargebackOutliers.length ? (
                <p className={ui.empty}>Nenhum outlier de chargeback.</p>
              ) : (
                <div className={ui.tblScroll}>
                  <table className={ui.tbl}>
                    <thead>
                      <tr>
                        <th>Loja</th>
                        <th className="r">Taxa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {h.chargebackOutliers.map((c) => (
                        <tr key={c.id}>
                          <td>
                            <b>{c.name}</b>
                            <div className={ui.faint}>{c.subdomain}</div>
                          </td>
                          <td className="r">
                            <span className={`${ui.pill} ${ui.pillDanger}`}>{pct(c.rate ?? 0)}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </section>

          <section>
            <div className={ui.secH}>
              <h2>Campanhas com falha alta</h2>
            </div>
            <div className={ui.card}>
              {!h?.failingCampaigns.length ? (
                <p className={ui.empty}>Nenhuma campanha com falha alta.</p>
              ) : (
                <div className={ui.tblScroll}>
                  <table className={ui.tbl}>
                    <thead>
                      <tr>
                        <th>Loja</th>
                        <th>Mensagem</th>
                        <th className="r">Falhas</th>
                      </tr>
                    </thead>
                    <tbody>
                      {h.failingCampaigns.map((c) => (
                        <tr key={c.id}>
                          <td className={ui.muted}>{c.storeName}</td>
                          <td className={ui.faint}>{c.text}</td>
                          <td className="r">
                            <span className={ui.mono}>
                              {c.failedCount}/{c.recipientCount}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
}
